import { Button } from "@mui/material";

export const NavigationButtons = ({
  isLastQuestion,
  currentQuestion,
  handleBack,
  handleMarkReviewDefault,
  handleClearResponse,
  handleSaveNextDefault,
  handleOpenSubmitModal,
  resetSelections,
  questionType,
  classes,
}) => {
  const ShowAlert = false;
  return (
    <div className={classes.btncontainer}>
      {/* Mobile-only Save button (full width) */}
      <div className={classes.mobileSaveContainer}>
        {isLastQuestion && (
          <Button
            variant="contained"
            className={classes.transparentbtnsavemobile}
            onClick={() => handleSaveNextDefault()}
            fullWidth
          >
            Save
          </Button>
        )}
      </div>

      {/* Regular buttons */}
      <div className={classes.regularButtonsContainer}>
        <div className={classes.leftButtons}>
          {
            currentQuestion > 0 && (
               <Button
            variant="contained"
            className={classes.bluebtn}
            onClick={handleBack}
            disabled={currentQuestion === 0}
          >
            Previous
          </Button>
            )
          }
          {/* <Button
            variant="contained"
            className={classes.transparentbtn}
            onClick={() => handleMarkReviewDefault("marked")}
          >
            Mark & Review
          </Button> */}
        </div>

        <div className={classes.rightButtons}>
          <Button
            variant="contained"
            className={classes.transparentbtn}
            onClick={
              questionType === "Multiple Choice"
                ? resetSelections
                : handleClearResponse
            }
          >
            Clear Response
          </Button>
          
            <Button
              variant="contained"
              className={classes.transparentbtnsave}
              onClick={() => handleSaveNextDefault()}
            >
            {isLastQuestion?'Save':'Save & Next'}  
            </Button>
          
          <Button
            variant="contained"
            className={classes.transparentbtn}
            onClick={() => {
                handleOpenSubmitModal();              
            }}
          >
           Submit
          </Button>
        </div>
      </div>
    </div>
  );
};
